<script setup>
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Textarea from "primevue/textarea";
import RadioButton from "primevue/radiobutton";
import InputGroup from "primevue/inputgroup";
import FileUploader from "../../../components/ui-components/FileUploader.vue";

const model = defineModel()
const props = defineProps({
    errors: Object,
})
</script>

<template>
    <div class="grid md:grid-cols-2 gap-5">
        <div>
            <label class="block font-semibold text-gray-700 dark:text-gray-100 mb-2">
                {{ $t('services.form_name') }} <span class="text-red-500">*</span>
            </label>
            <InputText v-model="model.name" class="w-full" :placeholder="$t('services.form_name_placeholder')"/>
            <span v-if="errors.name" class="text-red-500 text-sm">{{ errors.name }}</span>
        </div>

        <div>
            <label class="block font-semibold text-gray-700 dark:text-gray-100 mb-3">{{ $t('services.form_price_type') }}</label>
            <div class="flex gap-6">
                <div class="flex items-center gap-2">
                    <RadioButton inputId="price_fixed" value="fixed" v-model="model.price_preference"/>
                    <label for="price_fixed" class="cursor-pointer select-none">{{ $t('services.form_price_fixed') }}</label>
                </div>
                <div class="flex items-center gap-2">
                    <RadioButton inputId="price_range" value="range" v-model="model.price_preference"/>
                    <label for="price_range" class="cursor-pointer select-none">{{ $t('services.form_price_range') }}</label>
                </div>
            </div>
        </div>

        <div v-if="model.price_preference === 'fixed'">
            <label class="block font-semibold text-gray-700 dark:text-gray-100 mb-2">{{ $t('services.form_price') }}</label>
            <InputGroup>
                <InputNumber v-model="model.price" class="w-full" mode="currency" currency="CZK" locale="cs-CZ" size="small"/>
            </InputGroup>
            <span v-if="errors.price" class="text-red-500 text-sm">{{ errors.price }}</span>
        </div>

        <div v-if="model.price_preference === 'range'" class="grid grid-cols-2 gap-4">
            <div>
                <label class="block font-semibold text-gray-700 dark:text-gray-100 mb-2">{{ $t('services.form_price_min') }}</label>
                <InputGroup>
                    <InputNumber v-model="model.min_price" :max="model.max_price" :min="0" class="w-full" mode="currency" currency="CZK" locale="cs-CZ" size="small"/>
                </InputGroup>
                <span v-if="errors.min_price" class="text-red-500 text-sm">{{ errors.min_price }}</span>
            </div>
            <div>
                <label class="block font-semibold text-gray-700 dark:text-gray-100 mb-2">{{ $t('services.form_price_max') }}</label>
                <InputGroup>
                    <InputNumber v-model="model.max_price" :min="model.min_price" class="w-full" mode="currency" currency="CZK" locale="cs-CZ" size="small"/>
                </InputGroup>
                <span v-if="errors.max_price" class="text-red-500 text-sm">{{ errors.max_price }}</span>
            </div>
        </div>

        <div>
            <label class="block font-semibold text-gray-700 dark:text-gray-100 mb-2">{{ $t('services.form_duration_label') }}</label>
            <InputNumber v-model="model.length_in_minutes" :min="5" class="w-full" size="small" :placeholder="$t('services.form_duration_placeholder')"/>
            <span v-if="errors.length_in_minutes" class="text-red-500 text-sm">{{ errors.length_in_minutes }}</span>
        </div>

        <div class="md:col-span-2">
            <label class="block font-semibold text-gray-700 dark:text-gray-100 mb-2">
                {{ $t('services.form_description') }} <span class="text-red-500">*</span>
            </label>
            <Textarea v-model="model.description" class="w-full" rows="4" :resizable="false" :placeholder="$t('services.form_description_placeholder')"/>
            <span v-if="errors.description" class="text-red-500 text-sm">{{ errors.description }}</span>
        </div>

        <div class="md:col-span-2">
            <label class="block font-semibold text-gray-700 dark:text-gray-100 mb-2">{{ $t('services.form_image') }}</label>
            <FileUploader v-model:src="model.image"/>
        </div>
    </div>
</template>
